import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { SiteDetails, SiteListQuery, SitesRoot } from './types'

export const fetchSiteList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: SiteListQuery }) => {
  return wretchClient
    .url('/admin/1.0/sites')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<SitesRoot>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const fetchSiteDetails = async (params?: { abortCtrl?: AbortController | AbortSignal, id: string }) => {
  return wretchClient
    .url(`/admin/1.0/sites/${params?.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<[SiteDetails]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}

export const deleteSite = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/sites/${id}`)
    .delete()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addNewSite = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/sites`)
    .post(value)
    .json<SitesRoot>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const hostAdminAddNewSite = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/sites/by-host-admin`)
    .post(value)
    .json<SitesRoot>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateSite = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/sites`)
    .put(value)
    .json<SitesRoot>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const hostAdminUpdateSite = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/sites/by-host-admin`)
    .put(value)
    .json<SitesRoot>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
